import { render, staticRenderFns } from "./Unlink.vue?vue&type=template&id=1ec0d65d&scoped=true"
import script from "./Unlink.vue?vue&type=script&lang=js"
export * from "./Unlink.vue?vue&type=script&lang=js"
import style0 from "./Unlink.vue?vue&type=style&index=0&id=1ec0d65d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec0d65d",
  null
  
)

export default component.exports